<script setup lang="ts">
import { Splide, SplideTrack } from '@splidejs/vue-splide'
import type { Options } from '@splidejs/splide'
import '@splidejs/splide/dist/css/splide-core.min.css'

defineProps<{
  options?: Options
  itemShadow?: boolean
  disableArrows?: boolean
}>()

const slider = ref([])
defineExpose({
  slider,
})
</script>

<template>
  <Splide
    ref="slider"
    :has-track="false"
    :options="{
      gap: !itemShadow && '20px',
      pagination: true,
      perMove: 1,
      classes: {
        pagination: 'splide__pagination',
        page: 'splide__pagination__item',
      },
      ...options,
    }"
  >
    <SplideTrack>
      <slot />
    </SplideTrack>
    <slot name="arrows">
      <div v-if="!disableArrows" class="splide__arrows hidden xl:block">
        <div class="flex items-center h-full absolute -left-15" :class="[options?.pagination === false ? 'top-0' : 'bottom-4']">
          <div class="splide__arrow-box splide__arrow--prev">
            <AppIcon class="text-secondary-active" icon="fas-arrow-left" />
          </div>
        </div>
        <div class="flex items-center h-full absolute -right-15" :class="[options?.pagination === false ? 'top-0' : 'bottom-4']">
          <div class="splide__arrow-box splide__arrow--next">
            <AppIcon class="text-secondary-active" icon="fas-arrow-right" />
          </div>
        </div>
      </div>
    </slot>
  </Splide>
</template>

<style>
.splide__pagination {
  @apply flex mt-5 gap-5px justify-center;
}
.splide__pagination__item {
  @apply bg-secondary-active w-10px h-10px rounded-full bg-opacity-15;
  &.is-active {
    @apply bg-opacity-100;
  }
}
.splide__arrow-box {
  @apply z-10 cursor-pointer h-11 w-11 bg-secondary-active bg-opacity-10 rounded-xl
  flex items-center justify-center transition shadow-passive
  hover:border-secondary-active hover:shadow-hover hover:border-1;
}
</style>
